var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox',{attrs:{"indeterminate":_vm.isIndeterminate,"disabled":_vm.disabled},on:{"change":_vm.change},model:{value:(_vm.checkValue),callback:function ($$v) {_vm.checkValue=$$v},expression:"checkValue"}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }